import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { LoggingService } from "./logging.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
  constructor(private loggingService: LoggingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!environment.enableLogging) {
      return next.handle(req);
    }

    const isLogRequest =
      req.headers.has("X-Log-Request") ||
      req.url.startsWith(environment.logsUrl);
    if (isLogRequest) {
      return next.handle(req);
    }

    const request_timestamp = new Date().toISOString();
    const startTime = performance.now();

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse && req.method !== "GET") {
            const execution_time_ms = Math.round(performance.now() - startTime);

            const logData: any = {
              event_timestamp: request_timestamp,
              method: req.method,
              url: req.urlWithParams,
              response_status: event.status,
              execution_time_ms,
              event_type: "http_request",
            };

            if (["POST", "PUT", "PATCH"].includes(req.method)) {
              logData.body = req.body;
            }

            if (req.method === "DELETE") {
              logData.deleted_id = req.urlWithParams.split("/").pop();
            }

            this.loggingService.logEvent("http_request", logData);
          }
        },
        error: (error) => {
          const execution_time_ms = Math.round(performance.now() - startTime);

          const logData: any = {
            event_timestamp: request_timestamp,
            method: req.method,
            url: req.urlWithParams,
            response_status: error.status,
            execution_time_ms,
            level: "ERROR",
            error_message: error.message || "Unknown error",
            error_class: error.name || "HttpError",
          };

          if ([401, 403].includes(error.status)) {
            logData.event_type = "access_denied";
          } else if (error.status === 409) {
            logData.event_type = "duplicate_entry";
          } else {
            logData.event_type = "exception";
          }

          if (error.error?.stack) {
            logData.stacktrace = error.error.stack.split("\n");
          }

          this.loggingService.logEvent(logData.event_type, logData);
        },
      })
    );
  }
}
